import FoodsZikRme from "../../assets/FoodsZikRme.jpg";
import home1 from "../../assets/home1.jpg";
import home2 from "../../assets/home2.jpg";
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./HomeSlider.css";
const imgSlider = [
  { image: FoodsZikRme  },
  { image: home1 },
  { image: home2 },
];

const HomeSlider = () => {
  const settings = {
   
    infinite: true,
    speed: 500,
  
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        // settings: { slidesToShow: 1 },
        settings: { slidesToShow: 3 },
      },
    ],
  };

  return (
    <div className="main-box">
      <Slider {...settings}>
        {imgSlider.map((item, index) => (
          <div key={index} className="card">
            <img src={item.image} alt="img" className="slider-img"  style={{
                width: "97%",
                height: "400px",
                objectFit: "cover",
                display: "block",
                margin: "0 auto"
              }} />
            <hr />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HomeSlider;
